import {
  Box,
  Field,
  FilterTableWithQueryParams,
  Grid,
  Select,
  TextField,
} from "components";
import { allOption } from "constants/objects/claim_request_mapping_status";
import { EnumHospitalType } from "constants/enums/hospital_types";
import { compose, withHooks, withTranslation } from "enhancers";
import paths from "routes/paths";
import { Yup } from "utils/helper";

interface IPartnerHospitalListFilterInput {
  name?: string;
  isActive?: boolean | string;
  hospitalType?: string;
}

export const partnerHospitalListFilterInitialValues: IPartnerHospitalListFilterInput = {
  name: undefined,
  isActive: "all",
  hospitalType: "all",
};

const validationSchema = Yup.object().shape({});

const PartnerHospitalFilters = ({ t }: any) => (
  <FilterTableWithQueryParams
    initialValues={partnerHospitalListFilterInitialValues}
    path={paths.partnerHospitalPath}
    validationSchema={validationSchema}
  >
    <Box display="flex" flexDirection="column">
      <Grid container spacing={6} mt={6}>
        <Grid item xs={12} md={6}>
          <Field
            fast
            component={TextField}
            name="name"
            type="text"
            label={t(".name")}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Field
            fast
            component={Select}
            name="isActive"
            label={t(".status")}
            defaultValue={allOption}
            options={[
              allOption,
              {
                label: t(".active"),
                value: "active",
              },
              {
                label: t(".inactive"),
                value: "inactive",
              },
            ]}
            fullWidth
            disableClearable
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Field
            fast
            component={Select}
            name="hospitalType"
            label={t(".hospitalType")}
            options={[
              allOption,
              {
                label: t(`.${EnumHospitalType.GOVERNMENT}`),
                value: EnumHospitalType.GOVERNMENT,
              },
              {
                label: t(`.${EnumHospitalType.NON_GOVERNMENT}`),
                value: EnumHospitalType.NON_GOVERNMENT,
              },
            ]}
            fullWidth
            disableClearable
          />
        </Grid>
      </Grid>
    </Box>
  </FilterTableWithQueryParams>
);

const enhancer = compose(
  withTranslation({
    prefix: "pages.main.partnerHospitals.PartnerHospitalFilters",
  }),
  withHooks((props: any, hooks: any) => {
    const { t } = props;

    return { t };
  })
);

export default enhancer(PartnerHospitalFilters);
